import { render, staticRenderFns } from "./step-enviar-indicacao.vue?vue&type=template&id=78df3b19&"
import script from "./step-enviar-indicacao.vue?vue&type=script&lang=js&"
export * from "./step-enviar-indicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports